<template lang="pug">
  .Circle
    svg(
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"  
      viewBox="0 0 130.2 130.2"
      stroke="currentColor" 
    )
      circle(
        class="path circle" 
        fill="none" 
        stroke="currentColor" 
        stroke-width="6" 
        stroke-miterlimit="10" 
        cx="65.1" 
        cy="65.1" 
        r="62.1"
      )
      polyline(
        class="path check" 
        fill="none" 
        stroke="currentColor" 
        stroke-width="6" 
        stroke-linecap="round" 
        stroke-miterlimit="10" 
        points="95.2,45.2 51.5,88.8 32.8,70.5 "
      )
      
</template>

<script>
export default {
  name: "SuccessCircle"
}
</script>

<style lang="scss" scoped>

  svg {
    width: 100px;
    display: block;
    margin: 40px auto 0;
    color: #2FB872;
  }

  .path {
    stroke-dasharray: 1000;
    stroke-dashoffset: 0;
    &.circle {
      -webkit-animation: dash .9s ease-in-out;
      animation: dash .9s ease-in-out;
    }
    &.line {
      stroke-dashoffset: 1000;
      -webkit-animation: dash .9s .35s ease-in-out forwards;
      animation: dash .9s .35s ease-in-out forwards;
    }
    &.check {
      stroke-dashoffset: -100;
      -webkit-animation: dash-check .9s .35s ease-in-out forwards;
      animation: dash-check .9s .35s ease-in-out forwards;
    }
  }

  p {
    text-align: center;
    margin: 20px 0 60px;
    font-size: 1.25em;
    &.success {
      color: #2FB872;
    }
    &.error {
      color: #D06079;
    }
  }

  @-webkit-keyframes dash {
    0% {
      stroke-dashoffset: 1000;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  @keyframes dash {
    0% {
      stroke-dashoffset: 1000;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }

  @-webkit-keyframes dash-check {
    0% {
      stroke-dashoffset: -100;
    }
    100% {
      stroke-dashoffset: 900;
    }
  }

  @keyframes dash-check {
    0% {
      stroke-dashoffset: -100;
    }
    100% {
      stroke-dashoffset: 900;
    }
  }

</style>


